// extracted by mini-css-extract-plugin
export default {"content":"index_content__V5tpQ","text":"index_text__VAogc","animate":"index_animate__F8IiU"};